import '@/lenis'
import 'liquid-ajax-cart'

import AlpineCollapse from '@alpinejs/collapse'
import AlpineFocus from '@alpinejs/focus'
import AlpineMorph from '@alpinejs/morph'
import Alpine from 'alpinejs'
import 'virtual:shopify-modules'
import '../main.css'
// @ts-expect-error TODO: fix this
import { Core } from '@unseenco/taxi'

// import { BaseRenderer } from '@/renderers/default'
// import { ProductRenderer } from '@/renderers/product'
import AlpineGlobals from '@/alpine/index'
import { init } from '@/utils/gtm'
// import FadeTransition from '@/transitions/fade'

class App {
  taxi!: Core
  modules: any

  constructor() {
    setTimeout(this.init, 0)
  }

  init = () => {
    // Register and initialize AlpineJS
    window.Alpine = Alpine

    Alpine.plugin([AlpineCollapse, AlpineFocus, AlpineMorph])
    AlpineGlobals.register(Alpine)
    Alpine.start()

    // GTM
    init()

    // this.taxi = new Core({
    // 	links: 'a:not([target]):not([href^=\\#]):not([data-taxi-ignore]):not(.jdgm-paginate__page)',
    // 	removeOldContent: false,
    // 	renderers: {
    // 		default: BaseRenderer,
    // 		product: ProductRenderer
    // 	},
    // 	transitions: {
    // 		default: FadeTransition
    // 	},
    // 	reloadJsFilter: element => element.dataset.taxiReload !== undefined || element.dataset.locksmith !== undefined
    // })
  }
}

window._app = new App()
